import Vue from "vue"; //引入vue
import VueRouter from "vue-router"; //引入vue路由
import Login from "@/components/LoginPage.vue"; //登录页
import Home from "@/components/HomePage.vue"; //首页
import DataBoard from "@/components/DataBoardViews/DataBoard.vue"; //数据看板
import StatisticalReport from "@/components/DataBoardViews/StatisticalReport.vue"; //统计报表
import AutoPartsInventory from "@/components/AutomotivePartsViews/AutoPartsInventory.vue"; //配件库存
import CustomerInfo from "@/components/BusinessPartnerViews/CustomerInfo.vue"; //客户信息
import SupplierInfo from "@/components/BusinessPartnerViews/SupplierInfo.vue"; //供应商信息
import OrderInfo from "@/components/OrderViews/OrderInfo.vue"; //订单列表
import OrderDetail from "@/components/OrderViews/OrderDetail.vue"; //订单明细列表
import SupplierOrder from "@/components/OrderViews/SupplierOrder.vue"; //供应商结款列表
import RebateInfo from "@/components/DataBoardViews/RebateInfo.vue"; //反点

Vue.use(VueRouter); //挂在路由插件

const routes = [
  //路由表示的是url和组件的一一对应的关系，使用path属性表示url路径，使用component属性表示组件
  {
    path: "/",
    redirect: '/login'
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        redirect: 'DataBoardViews/DataBoard'
      },
      {
        path: "DataBoardViews/DataBoard",
        name: "DataBoard",
        component: DataBoard,
        meta: { requiresAuth: true },
      },
      {
        path: "DataBoardViews/StatisticalReport",
        name: "StatisticalReport",
        component: StatisticalReport,
        meta: { requiresAuth: true },
      },
      {
        path: "DataBoardViews/RebateInfo",
        name: "RebateInfo",
        component: RebateInfo,
        meta: { requiresAuth: true },
      },
      {
        path: "AutomotivePartsViews/AutoPartsInventory",
        name: "AutoPartsInventory",
        component: AutoPartsInventory,
        meta: { requiresAuth: true },
      },
      {
        path: "BusinessPartnerViews/CustomerInfo",
        name: "CustomerInfo",
        component: CustomerInfo,
        meta: { requiresAuth: true },
      },
      {
        path: "BusinessPartnerViews/SupplierInfo",
        name: "SupplierInfo",
        component: SupplierInfo,
        meta: { requiresAuth: true },
      },
      {
        path: "OrderViews/OrderInfo",
        name: "OrderInfo",
        component: OrderInfo,
        meta: { requiresAuth: true },
      },
      {
        path: "OrderViews/OrderDetail",
        name: "OrderDetail",
        component: OrderDetail,
        meta: { requiresAuth: true },
      },
      {
        path: "OrderViews/SupplierOrder",
        name: "SupplierOrder",
        component: SupplierOrder,
        meta: { requiresAuth: true },
      },
    ]
  }
];
const router = new VueRouter({
  // 生成一个路由实例
  routes, // 配置项-配置视图和路由之间的对应关系
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !localStorage.getItem("authToken")) {
    next("/login");
  } else {
    next();
  }
});

//修改原型对联 的push
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router; // 导出路由实例
